import clsx from 'clsx';
import {
  useContext,
  useLayoutEffect,
  useCallback,
  useRef,
  useEffect,
} from 'haunted/lib/core';

import { component } from '../../utils';
import { AccordionContext } from '../accordion/accordion.context';

import './accordion-tab.css';

function AccordionTab(el: HTMLElement): null {
  const context = useContext(AccordionContext);
  const onClick = useCallback(() => {
    if (el.dataset.slideId) {
      context.handleItemClick(el.dataset.slideId);
    }
  }, [context]);
  const initialClassNames = useRef(el.className);

  useLayoutEffect(() => {
    el.setAttribute('role', 'button');
    el.onclick = onClick;
  }, [onClick]);

  useEffect(() => {
    if (context?.openIndexes?.indexOf(el.dataset.slideId) !== -1) {
      // This tab is currently active
      if (el.dataset.activeClass) {
        el.className = clsx(initialClassNames.current, el.dataset.activeClass);
      }

      el.dataset.state = 'active';
    } else {
      // This tab is not active (initial state)
      el.className = clsx(initialClassNames.current, el.dataset.inactiveClass);
      el.dataset.state = 'initial';
    }
  }, [context, el.dataset.slideId]);

  // Do not replace child content
  return null;
}

export const AccordionTabElement = component(AccordionTab, {
  useShadowDOM: false,
});
